<template>
    <div class="warn-line-box" :style="dialongStyle">
        <div class="warn-line-box-top">
            <div>警戒线设置</div>
            <div class="el-icon-close" @click="$emit('closeShowDialog', false)"></div>
        </div>
        <div class="warn-line-box-bottom">
            <span>描边粗细</span>
            <div style="width: 0; display: inline-block; margin-left: 10px">
                <el-input-number
                    v-model="pxNum"
                    label="px"
                    controls-position="right"
                    @change="handleChange"
                    style="text-align: left"
                ></el-input-number>
            </div>
            <div style="margin-top: 10px">
                <el-button class="btn" type="primary" @click="$emit('closeShowDialog', false)"
                    >取消</el-button
                >
                <el-button class="btn btn-confirm" type="primary" @click="setLineWidth(pxNum)"
                    >确认</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dialongStyle: Object,
        showDialog: Boolean,
        setLineWidth: Function,
    },
    data() {
        return {
            pxNum: 0,
        };
    },
    methods: {
        handleChange(value) {
            this.pxNum = value;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number--small {
    position: relative;

    width: 74px;
    &::before {
        content: 'px';
        position: absolute;
        top: -1px;
        right: 30px;
        font-size: 12px;
    }
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
    background: rgba(7, 17, 80, 0);
    color: #fff;
    border: 0px !important;
    line-height: 20px !important;
}
::v-deep .el-input-number.is-controls-right .el-input-number__increase {
    border: 0;
}

::v-deep .el-input-number.is-controls-right .el-input__inner {
    background: rgba(7, 17, 80, 0);
    padding-left: 10px;
    padding-right: 0;
    text-align: left;
    width: 100% !important;
    color: #fff;
    border: 1px solid #ffffff4d;
}
::v-deep .el-icon-arrow-up:before {
    content: '\e78f';
}
::v-deep .el-icon-arrow-down:before {
    content: '\e790';
}
.warn-line-box {
    width: 180px;
    height: 130px;
    font-size: 14px;
    color: #fff;
    background: rgba(7, 17, 80, 0.8);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #49f0fd;
    .warn-line-box-top {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #49f0fd;

        .el-icon-close {
            cursor: pointer;
        }
    }
    .warn-line-box-bottom {
        padding: 10px 20px;
        .btn {
            width: 64px;
            line-height: 8px;
            background: rgba(73, 240, 253, 0.2);
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #49f0fd;
            &.btn-confirm {
                margin-left: 12px;
                color: #071150ff;
                background: #49f0fd;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #49f0fd;
            }
        }
    }
    &::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 10px;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 10px solid #49f0fd;
    }
}
</style>
